import { useQuery } from '@tanstack/react-query'
import React from 'react'
import ReactMarkdown from 'react-markdown'

import ReviewStats from '@/components/misc/CompanyProfile/tabs/ReviewsTab/components/ReviewStats'
import SkeletonRow from '@/components/skeleton/SkeletonRow'
import reviewService from '@/lib/services/reviewService'

interface Props {
  reviewId: number
}

const ReviewDetails: React.FC<Props> = ({ reviewId }) => {
  const reviewQuery = useQuery({
    queryKey: ['review-details', { reviewId }],
    queryFn: () => reviewService.getReview(reviewId),
  })

  const review = reviewQuery.data

  if (reviewQuery.isLoading) {
    return <SkeletonRow />
  }

  if (!review || reviewQuery.error) {
    throw new Error(`Failed to fetch review with ID: ${reviewId}`)
  }

  return (
    <div className="grid grid-cols-12 gap-4">
      <div className="col-span-full lg:col-span-8">
        <div className="ReviewDetails__body">
          <ReactMarkdown>{review.body}</ReactMarkdown>
        </div>
      </div>

      <div className="col-span-full lg:col-span-4">
        <ReviewStats review={review} />
      </div>
    </div>
  )
}

export default ReviewDetails
